<template>
	<popup v-model="innerVisible" position="bottom">
		<div class="m-footer-popup-header thinner-border-bottom">
			<span class="m-footer-title">{{ $t('enterprise.whistleblower') }}</span>
			<SvgIcons name="icon_close" class="m-footer-close" @click="closePopup" />
		</div>
		<div class="m-footer-popup-main">
			<div class="m-footer-paragraph">{{ content.p1 }}</div>
			<a href="mailto:voice@robosense.cn" class="c-body-hot">
				<SvgIcons name="icon_feedback" class="c-body-hot-svg" />
				<span class="c-body-hot-content">{{ content.hot }}</span>
			</a>
			<div class="m-footer-paragraph">{{ content.p2 }}</div>
		</div>
	</popup>
</template>

<script setup>
import { Popup } from 'vant';
import { ref, computed } from 'vue';
import i18n, { ZH, ZH_HK, EN } from '@/locales';

const props = defineProps({
	visible: {
		type: Boolean,
		default: false
	}
});
const emits = defineEmits(['update:visible']);
const innerVisible = computed({
	get() {
		if (props.visible) getContent();
		return props.visible;
	},
	set(val) {
		emits('update:visible', val);
	}
});

const closePopup = () => {
	innerVisible.value = false;
};

const content = ref({});
const getContent = () => {
	const email = 'voice@robosense.cn';
	const localMap = {
		[ZH]: {
			p1: 'RoboSense员工应遵守清廉自守的职业规范，如您发现我们的员工有不廉洁、徇私舞弊的违规违纪行为，可以通过邮箱向我们进行举报。',
			hot: `举报邮箱: ${email}`,
			p2: '我们鼓励实名举报，对举报内容在合理的限度内予以保密。\n如果您有对RoboSense其他业务的咨询或投诉，请直接使用相关业务的查询或投诉途径，以便您的问题能够及时得到解决，谢谢。'
		},
		[ZH_HK]: {
			p1: 'RoboSense員工應遵守清廉自守的職業規範，如您發現我們的員工有不廉潔、徇私舞弊的違規違紀行爲，可以通過郵箱向我們進行舉報。',
			hot: `舉報郵箱: ${email}`,
			p2: '我們鼓勵實名舉報，對舉報内容在合理的限度内予以保密。\n如果您有對RoboSense其他業務的咨詢或投訴，請直接使用相關業務的查詢或投訴途徑，以便您的問題能夠及時得到解決，謝謝。'
		},
		[EN]: {
			p1: 'RoboSense employees should abide by the professional norms of integrity and self-discipline. If you find that our employees have violated regulations such as incorruptibility and favoritism, you can report them to us via email.',
			hot: `Report Email: ${email}`,
			p2: 'We encourage real-name reporting and keep the reported content confidential within reasonable limits.\nIf you have any inquiries or complaints about other RoboSense businesses, please directly use the relevant business inquiry or complaint channels so that your problem can be resolved in a timely manner. Thank you.'
		}
	};
	content.value = localMap[i18n.locale];
};
</script>

<style>
.van-popup {
	border-radius: 8px 8px 0 0;
}
</style>
<style lang="less" scoped>
.m-footer-popup-header {
	height: 50px;
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;

	/deep/ &.thinner-border-bottom::before {
		border-bottom-color: #f0f0f0;
	}
	.m-footer-title {
		color: #12121a;
		text-align: center;
		 
		font-size: 16px;
		font-weight: 500;
	}
	.m-footer-close {
		position: absolute;
		top: 0;
		right: 16px;
		bottom: 0;
		margin: auto;
		font-size: 16px;
	}
}
.m-footer-popup-main {
	padding: 12px 14px 58px;
	display: flex;
	flex-direction: column;
	align-items: center;

	.m-footer-paragraph {
		color: #4e5969;
		 
		font-size: 14px;
		 
		font-weight: 400;
		line-height: 22px; /* 157.143% */
		white-space: pre-wrap;
	}
	.c-body-hot {
		margin: 24px 0;
		padding: 12px;
		display: inline-flex;
		align-items: center;
		background: #f7f8fa;
	}
	.c-body-hot-content {
		margin-left: 8px;
		color: #4e5969;
		 
		font-size: 14px;
		 
		font-weight: 400;
		line-height: 18px; /* 128.571% */
	}
	.c-body-hot-svg {
		font-size: 24px;
		color: #4e5969 !important;
	}
}
</style>
